<template>
  <div class="mobile-subscription">
    <subscription-form />
  </div>
</template>

<script>
import SubscriptionForm from '~/components/subscribe/subscription-form'

export default {
  components: {
    SubscriptionForm
  }
}
</script>

<style lang="scss" scoped>
  .mobile-subscription {
    margin-top: $space-060;
    margin-left: $space-060;
    margin-right: $space-060;
    padding: 0;
  }
</style>
